import { render } from "./page-scaffold.vue?vue&type=template&id=38011682&scoped=true"
import script from "./page-scaffold.vue?vue&type=script&lang=js"
export * from "./page-scaffold.vue?vue&type=script&lang=js"

import "./page-scaffold.vue?vue&type=style&index=0&id=38011682&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38011682"]])

export default __exports__